module.exports = __webpack_public_path__ + "static/media/monster_logo.8c8178cf.png";